// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-8cd30f96],.fade-leave-active[data-v-8cd30f96]{transition:opacity .2s}.fade-enter[data-v-8cd30f96],.fade-leave-to[data-v-8cd30f96]{opacity:0}", ""]);
// Exports
module.exports = exports;
